import React from "react"

import classes from "./ColorPickerInput.module.scss"

const ColorPickerInput = ({ color = "#000000", onChange }) => (
  <label className={classes["color-input-container"]}>
    <span
      className={classes["color-preview"]}
      style={{ backgroundColor: color }}
    />
    <input
      type="color"
      value={color}
      onChange={event => onChange(event.target.value)}
      className={classes["color-input"]}
    />
  </label>
)

export default ColorPickerInput
